/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { logLog } from '../fn/log/log-log';
import { LogLog$Params } from '../fn/log/log-log';

@Injectable({ providedIn: 'root' })
export class LogService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `logLog()` */
  static readonly LogLogPath = '/api/Log';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `logLog()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  logLog$Response(params?: LogLog$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return logLog(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `logLog$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  logLog(params?: LogLog$Params, context?: HttpContext): Observable<void> {
    return this.logLog$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
